/**
 * 服务端转发身份头注入（纯函数，无任何运行时依赖）。
 *
 * SSR 场景下我方服务作为反向代理向后端发起请求时，
 * 统一在这里注入服务 User-Agent 与客户端 IP，避免多处重复实现。
 */

export interface ForwardedIdentity {
  /** 服务 User-Agent；为空时保持 headers 原值 */
  userAgent?: string | null
  /** 已通过校验的客户端 IP；为空时不注入 */
  clientIP?: string | null
}

/**
 * 注入代理转发身份头：
 * - user-agent：应用提供的服务 UA，无值时不动
 * - x-real-ip：客户端真实 IP（单值，可信来源）
 * - x-forwarded-for：与 HQ 一致，覆盖为同一个已解析的客户端 IP
 */
export function applyForwardedHeaders(headers: Headers, identity: ForwardedIdentity): void {
  if (identity.userAgent) {
    headers.set("user-agent", identity.userAgent)
  }

  if (identity.clientIP) {
    headers.set("x-real-ip", identity.clientIP)
    headers.set("x-forwarded-for", identity.clientIP)
  }
}
